import {EventEmitter, Injectable} from '@angular/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs/index';
import {ApprovalPending} from '../dto/approval-pending';
import {AppConfig} from '../common/app.config';

@Injectable({
  providedIn: 'root'
})
export class SuspendBlacklistService {
  constructor(private httpClient: HttpClient, private appConfig: AppConfig) {
  }

  baseUrl: string =  this.appConfig.getConfig('BASE_URL') + 'api/';
  private headers;
  public model = new EventEmitter<NgbModal>();
  public closeModel: NgbModal;


  getAllReturnRequestData(data: ApprovalPending): Observable<Object> {
    return this.httpClient.post(this.baseUrl + 'suspend-blacklist/getReturnRequest', data);
  }

  getAllDGReturnRequestData(data: ApprovalPending): Observable<Object> {
    return this.httpClient.post(this.baseUrl + 'suspend-blacklist/getDGReturnRequest', data);
  }

  searchPendingRequestData(data: ApprovalPending): Observable<Object> {
    return this.httpClient.post(this.baseUrl + 'suspend-blacklist/searchPendingRequests', data);
  }

  searchApplicantDetails(applicationId: number): Observable<Object> {
    return this.httpClient.get(this.baseUrl + 'suspend-blacklist/getApplicantDetails/'+ applicationId);
  }

  getPendingVerificationRequests(approvalPending: ApprovalPending): Observable<Object>{
    return this.httpClient.post(this.baseUrl + 'suspend-blacklist/getPendingRequests',approvalPending, {headers: this.headers});
  }

  getPendingAuthorizationRequests(approvalPending: ApprovalPending): Observable<Object>{
    return this.httpClient.post(this.baseUrl + 'suspend-blacklist/getPendingAuthList',approvalPending, {headers: this.headers});
  }

  close() {
    this.closeModel.dismissAll();
  }
}
